<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")

  section.u-mt-md
    Query(
      :query="require('~/graphql/Article.gql').Articles"
      :limit="10"
      :initialValue="articles"
      :variables="({ first, after }) => ({ first, after, publishedIn: 'INSIGHTS' })"
      v-slot="{ items }"
    )
      AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
        AppCard.is-work(:img="[{ srcset: item.thumb, type: 'image/jpg', ratio }]" :ratio="ratio" :title="item.title" :url="`/insights/${item.slug}`")

  .u-mb-md

</template>

<script>
import AsymetricGrid from '~/components/PsudoRandomGrid';
import { Articles } from '~/graphql/Article.gql';
import Query from '~/components/Query';

export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  },
  components: {
    AsymetricGrid,
    Query
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Articles,
      variables: {
        publishedIn: 'INSIGHTS',
        first: 10
      }
    });

    return {
      articles: data.articles
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat insights",
    "pageDesc":"Explore Baianat insights and inventions in both business and creative fields. Get a glimpse into the latest done inside our kitchen.",
    "mantra":"Innovating solutions |for business dilemmas."
  },
  "ar": {
    "pageTitle":"الرؤي",
    "pageDesc":"اكتشف رؤي بيانات والاختراعات في مجالات الأعمال التجارية والإبداعية، وتعرف على أحدث ما قمنا به حتى الآن.  ",
    "mantra":" حلول مبتكرة من أجل |مشكلات الأعمال التجارية"
  }
}
</i18n>
